module.exports = __webpack_public_path__ + "img/rjcCertifiedMember.83ffe11.jpg";